import { Form, InputGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faTimes } from "@fortawesome/free-solid-svg-icons";
import { memo, useCallback } from "react";

interface RecordingSearchProps {
  searchTerm: string;
  onSearchChange: (term: string) => void;
  placeholder?: string;
  disabled?: boolean;
}

const RecordingSearch = memo(function RecordingSearch({
  searchTerm,
  onSearchChange,
  placeholder = "Search recordings...",
  disabled = false
}: RecordingSearchProps) {
  
  const handleClear = useCallback(() => {
    onSearchChange("");
  }, [onSearchChange]);

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    onSearchChange(e.target.value);
  }, [onSearchChange]);

  return (
    <InputGroup className="mb-3">
      <InputGroup.Text style={{ backgroundColor: "#495057", borderColor: "#6c757d" }}>
        <FontAwesomeIcon icon={faSearch} color="#fff" />
      </InputGroup.Text>
      <Form.Control
        type="text"
        placeholder={placeholder}
        value={searchTerm}
        onChange={handleChange}
        disabled={disabled}
        style={{
          backgroundColor: "#495057",
          borderColor: "#6c757d",
          color: "#fff"
        }}
      />
      {searchTerm && (
        <InputGroup.Text 
          style={{ 
            backgroundColor: "#495057", 
            borderColor: "#6c757d",
            cursor: "pointer"
          }}
          onClick={handleClear}
        >
          <FontAwesomeIcon icon={faTimes} color="#fff" />
        </InputGroup.Text>
      )}
    </InputGroup>
  );
});

export default RecordingSearch;